import React, { useEffect, useState } from "react";
import { getWithTokenAPI, deleteWithTokenAPI, putAPI } from "../../utils/Api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaAddressCard } from "react-icons/fa";
import {
  CircularProgress,
  Box,
  Typography,
  Avatar,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  InputLabel,
  Pagination,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  ShoppingCart as ShoppingCartIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  CalendarToday as CalendarTodayIcon,
  Receipt as ReceiptIcon,
  LocalOffer as LocalOfferIcon,
  Edit as EditIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import FlightIcon from "@mui/icons-material/Flight";

const Cart = () => {
  const [dornes, setdrone] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCart, setSelectedCart] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [currentBookingStatus, setCurrentBookingStatus] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [dronesPerPage] = useState(10);

  const primaryGreen = "#DC3545";
  const lightGreen = "#ffe5e5";
  const darkGreen = "#b02a37";

    const permissions = JSON.stringify(localStorage.getItem("permissions"))

  const fetchCartItems = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const res = await getWithTokenAPI(token, "/drone-booking/find-all");
      console.log("Fetched dorne items:", res);
      if (res.statusCode === 200) {
        setdrone(res.data.drones || []);
      } else {
        toast.error(res.message || "Failed to load drone booking.");
        setdrone([]);
      }
    } catch (error) {
      console.error("Fetch drone error:", error);
      toast.error("Failed to load drone due to a network error.");
      setdrone([]);
    } finally {
      setLoading(false);
    }
  };

  const indexOfLastOrder = currentPage * dronesPerPage;
  const indexOfFirstOrder = indexOfLastOrder - dronesPerPage;
  const currentDornes = dornes.slice(indexOfFirstOrder, indexOfLastOrder);
  const totalPages = Math.ceil(dornes.length / dronesPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleViewCart = (dorne) => {
    setSelectedCart(dorne);
    setOpenViewDialog(true);
  };

  const handleEditCart = (dorne) => {
    setSelectedCart(dorne);
    setCurrentBookingStatus(dorne.Booking_status);
    setOpenEditDialog(true);
  };

  const handleUpdateBookingStatus = async () => {
    if (!selectedCart || !currentBookingStatus) {
      toast.error("No booking selected or status not set.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authentication token missing. Please log in again.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        _id: selectedCart._id,
        Booking_status: currentBookingStatus,
      };
      const response = await putAPI(token, "/drone-booking/update", payload);
      if (response.statusCode === 200) {
        toast.success("Booking status updated successfully!");
        setOpenEditDialog(false);
        fetchCartItems();
      } else {
        toast.error(response.message || "Failed to update booking status.");
      }
    } catch (error) {
      console.error("Update booking status error:", error);
      toast.error("Network error. Failed to update booking status.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCartItems();
  }, []);

  return (
    <Box
      sx={{
        p: 1,
        width: "100%",
      }}
    >
      <ToastContainer position="top-center" autoClose={1500} />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          p: 2,
          backgroundColor: lightGreen,
          borderRadius: 2,
          borderLeft: `5px solid ${primaryGreen}`,
        }}
      >
        <FlightIcon sx={{ color: primaryGreen, fontSize: 40, mr: 2 }} />
        <Box>
          <Typography
            variant="h4"
            component="h1"
            sx={{ color: primaryGreen, fontWeight: "bold" }}
          >
            Drone
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            Manage Drone Bookings
          </Typography>
        </Box>
      </Box>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress sx={{ color: primaryGreen }} />
          <Typography sx={{ ml: 2, color: primaryGreen }}>
            Loading Drone items...
          </Typography>
        </Box>
      ) : dornes.length > 0 ? (
        <>
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: 3,
              borderRadius: 2,
              border: `1px solid ${lightGreen}`,
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="drone bookings table">
              <TableHead>
                <TableRow sx={{ backgroundColor: lightGreen }}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    User
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    Crop Type
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    Total Amount(Ksh)
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    Tax Amount(Ksh)
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    Services
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    Spraying Date
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    Payment Status
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    Booking Status
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentDornes.map((dorne, index) => (
                  <TableRow key={dorne._id} hover>
                    <TableCell sx={{ textAlign: "center" }}>
                      {indexOfFirstOrder + index + 1}
                    </TableCell>
                    <TableCell sx={{
                      textAlign: "center", fontWeight: "bold",
                      color: primaryGreen,
                      textDecoration: 'none',
                      cursor: 'pointer',
                    }}
                      onClick={() => handleViewCart(dorne)}>
                      {dorne.user_id?.name || "-"}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {dorne.croptype}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {dorne.total_amount || 0}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {dorne.tax_amount || 0}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {dorne.service}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {new Date(dorne.sprayingdate).toLocaleDateString()}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <Chip
                        label={dorne.payment_status || "Pending"}
                        size="small"
                        sx={{
                          backgroundColor:
                            dorne.payment_status === "Paid"
                              ? lightGreen
                              : dorne.payment_status === "Failed"
                                ? "#ffebee"
                                : "#fff3e0",
                          color:
                            dorne.payment_status === "Paid"
                              ? darkGreen
                              : dorne.payment_status === "Failed"
                                ? "#d32f2f"
                                : "#e65100",
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <Chip
                        label={dorne.Booking_status || "Pending"}
                        size="small"
                        sx={{
                          backgroundColor:
                            dorne.Booking_status === "Approved"
                              ? lightGreen
                              : dorne.Booking_status === "Rejected"
                                ? "#ffebee"
                                : "#fff3e0",
                          color:
                            dorne.Booking_status === "Approved"
                              ? darkGreen
                              : dorne.Booking_status === "Rejected"
                                ? "#d32f2f"
                                : "#e65100",
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {new Date(dorne.createdAt).toLocaleDateString()}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center", display: "flex" }}>
                      <IconButton
                        onClick={() => handleViewCart(dorne)}
                        sx={{ color: primaryGreen }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                      {
                            permissions.includes("update_drone") && (
 
                      <IconButton
                        onClick={() => handleEditCart(dorne)}
                        sx={{ color: primaryGreen }}
                      >

                        <EditIcon />
                      </IconButton>
)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              mt: 3,
              pb: 2,
            }}
          >
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="green"
              sx={{
                "& .MuiPaginationItem-root": {
                  color: primaryGreen,
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: primaryGreen,
                  color: "white",
                },
              }}
            />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 4,
            textAlign: "center",
          }}
        >
          <Box sx={{ color: "text.disabled" }}>
            <FlightIcon sx={{ fontSize: 60, mr: 2 }} />
            <Typography variant="h6" sx={{ mb: 1 }}>
              No drone bookings found
            </Typography>
          </Box>
        </Box>
      )}

      {/* <Dialog
        open={openViewDialog}
        onClose={() => setOpenViewDialog(false)}
        maxWidth="lg"
        fullWidth
      > */}
      <Dialog
        open={openViewDialog}
        onClose={() => setOpenViewDialog(false)}
        fullWidth
        fullScreen  // This makes the dialog full screen
        sx={{
          "& .MuiDialog-paper": {
            m: 0,  // Remove margin
            width: "100%",  // Full width
            maxWidth: "100%",  // Override maxWidth
          }
        }}
      >
        {selectedCart && (
          <>
            <DialogTitle
              sx={{
                backgroundColor: primaryGreen,
                color: "white",
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div className="d-flex align-items-center">
                <ReceiptIcon sx={{ mr: 1 }} />
                Drone Details
              </div>
              <button
                className="btn-close btn-close-white"
                onClick={() => setOpenViewDialog(false)}
              ></button>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 3 }}>
              <Grid
                container
                className="d-flex gap-2 justify-content-evenly"
                spacing={4}
              >
                <Grid>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      border: `1px solid ${lightGreen}`,
                      borderRadius: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        color: darkGreen,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <PersonIcon sx={{ mr: 1 }} />
                      User Information
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Avatar
                        src={selectedCart.user_id?.profile_image}
                        sx={{ width: 60, height: 60, mr: 2 }}
                      >
                        {selectedCart.user_id?.name?.charAt(0) || "U"}
                      </Avatar>
                      <Box>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          {selectedCart.user_id?.name || "N/A"}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          ID: {selectedCart.user_id?._id || "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ pl: 2 }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 1 }}
                      >
                        <EmailIcon sx={{ color: darkGreen, mr: 1 }} />
                        <Typography variant="body2">
                          {selectedCart.user_id?.email || "N/A"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 1 }}
                      >
                        <PhoneIcon sx={{ color: darkGreen, mr: 1 }} />
                        <Typography variant="body2">
                          {selectedCart.user_id?.phone_number || "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>

                <Grid>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      border: `1px solid ${lightGreen}`,
                      borderRadius: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        color: darkGreen,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ReceiptIcon sx={{ mr: 1 }} />
                      Order Summary
                    </Typography>
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Order ID:</span>
                        <span style={{ fontWeight: "bold" }}>
                          {selectedCart._id}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Status:</span>
                        <Chip
                          label={selectedCart.payment_status || "Pending"}
                          size="small"
                          sx={{
                            backgroundColor:
                              selectedCart.payment_status === "Paid"
                                ? lightGreen
                                : selectedCart.payment_status === "Failed"
                                  ? "#ffebee"
                                  : "#fff3e0",
                            color:
                              selectedCart.payment_status === "Paid"
                                ? darkGreen
                                : selectedCart.payment_status === "Failed"
                                  ? "#d32f2f"
                                  : "#e65100",
                          }}
                        />
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Created:</span>
                        <span>
                          {new Date(selectedCart.createdAt).toLocaleString()}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Spraying Date:</span>
                        <span>
                          {new Date(
                            selectedCart.sprayingdate
                          ).toLocaleDateString()}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Tax Amount(Ksh):</span>
                        <span>
                          {selectedCart.tax_amount?.toFixed(2) || "0.00"}
                        </span>
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: lightGreen,
                        p: 2,
                        borderRadius: 1,
                        borderLeft: `3px solid ${primaryGreen}`,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", mb: 1 }}
                      >
                        Total(Ksh):
                        {selectedCart.total_amount?.toFixed(2) || "0.00"}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>

                <Grid item>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      width: "250px",
                      border: `1px solid ${lightGreen}`,
                      borderRadius: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        color: darkGreen,
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <FaAddressCard />
                      Address
                    </Typography>
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Name :</span>
                        <span>{selectedCart.address_id?.name || "N/A"}</span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Country :</span>
                        <span>{selectedCart.address_id?.country || "N/A"}</span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>State :</span>
                        <span>{selectedCart.address_id?.state || "N/A"}</span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>City :</span>
                        <span>{selectedCart.address_id?.city || "N/A"}</span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Street :</span>
                        <span>{selectedCart.address_id?.street || "N/A"}</span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>zip_code :</span>
                        <span>
                          {selectedCart.address_id?.zip_code || "N/A"}
                        </span>
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
              <Button
                onClick={() => setOpenViewDialog(false)}
                variant="outlined"
                sx={{ color: darkGreen, borderColor: darkGreen }}
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      <Dialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        {selectedCart && (
          <>
            <DialogTitle
              sx={{
                backgroundColor: primaryGreen,
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "16px 24px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <EditIcon sx={{ mr: 1 }} />
                <Typography variant="h6">
                  Edit Booking Status for {selectedCart.user_id?.name || "N/A"}
                </Typography>
              </Box>
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => setOpenEditDialog(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 3 }}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Current Booking Status:{" "}
                <Chip
                  label={selectedCart.Booking_status}
                  size="small"
                  sx={{
                    backgroundColor:
                      selectedCart.Booking_status === "Approved"
                        ? lightGreen
                        : selectedCart.Booking_status === "Rejected"
                          ? "#ffebee"
                          : "#fff3e0",
                    color:
                      selectedCart.Booking_status === "Approved"
                        ? darkGreen
                        : selectedCart.Booking_status === "Rejected"
                          ? "#d32f2f"
                          : "#e65100",
                  }}
                />
              </Typography>
              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend" sx={{ mb: -1, color: darkGreen }}>
                  Update Status
                </FormLabel>
                <Select
                  value={currentBookingStatus}
                  onChange={(e) => setCurrentBookingStatus(e.target.value)}
                  label="Booking Status"
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button
                onClick={() => setOpenEditDialog(false)}
                variant="outlined"
                sx={{ color: darkGreen, borderColor: darkGreen }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleUpdateBookingStatus}
                variant="contained"
                sx={{
                  bgcolor: primaryGreen,
                  "&:hover": { bgcolor: darkGreen },
                }}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Update Status"
                )}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default Cart;
